import React from 'react'
import { EmptyState } from '@/components/EmptyState'

export type EmptyStateBlockProps = {
  emoji?: string | null
  title: string
  message?: string | null
  actionLabel?: string | null
  actionHref?: string | null
  className?: string
  blockType: 'emptyState'
}

export const EmptyStateBlock: React.FC<EmptyStateBlockProps> = ({
  emoji,
  title,
  message,
  actionLabel,
  actionHref,
  className,
}) => {
  const action = actionLabel && actionHref ? { label: actionLabel, href: actionHref } : undefined
  return (
    <EmptyState
      emoji={emoji || undefined}
      title={title}
      message={message || undefined}
      action={action}
      className={className}
    />
  )
}
